import { combineReducers } from 'redux';

import byQuery from './byQuery/reducer';

export default combineReducers({
  byQuery
});



/** WEBPACK FOOTER **
 ** ./src/members/state/search/paging/results/reducer.js
 **/